import { DOMType, ChildrenDOMType } from '@tencent/exeditor3-core';
const sum = (n) => n.reduce((r, c) => r + c, 0);
const cellSpecBase = {
    type: DOMType.BLOCK,
    childrenType: ChildrenDOMType.BLOCK,
    isolating: true,
    group: '',
    attrs: {
        colspan: {
            default: 1,
            parse: (node) => node.colSpan,
            toDOMAttribute: (colspan) => ({ colspan }),
        },
        rowspan: {
            default: 1,
            parse: (node) => node.rowSpan,
            toDOMAttribute: (rowspan) => ({ rowspan }),
        },
        // NOTE: colwidth 解析自 data-colwidth, data-colwidth 由本插件产生
        //       同时提供给 prosemirror-tables editing/columnResizing 使用
        colwidth: {
            default: null,
            parse: (node) => {
                const colwidth = node.dataset.colwidth
                    ? node.dataset.colwidth.split(',').map((n) => Number(n))
                    : null;
                if (colwidth) {
                    return colwidth;
                }
                // 兼容 html style
                const width = node.style.width;
                const value = width ? [parseInt(width, 10)] : null;
                return value || null;
            },
            toDOMAttribute: (colwidth) => colwidth
                ? {
                    // 兼容 html style
                    style: `width: ${sum(colwidth)}px`,
                    'data-colwidth': colwidth.join(','),
                }
                : null,
        },
    },
};
export const dependencies = [
    {
        ...cellSpecBase,
        name: 'tableCell',
        matchSelector: 'td',
        tableRole: 'cell',
        toDOM: 'td',
    },
    {
        name: 'tableRow',
        type: DOMType.BLOCK,
        childrenType: '(tableCell | tableHeader)*',
        matchSelector: 'tr',
        group: '',
        tableRole: 'row',
        toDOM: 'tr',
    },
    {
        ...cellSpecBase,
        name: 'tableHeader',
        matchSelector: 'th',
        tableRole: 'header_cell',
        toDOM: 'th',
    },
];
//# sourceMappingURL=dependencies.js.map